//import { useState } from 'react';
import './CartIcon.css';

function CartIcon(props) {
  //   const [update, setNewUpdate] = useState(props.update);
  //   const [loading, isLoading] = useState(props.loading);

  return (
    <div className="row cfa-nowrap-row cfa-button">
      <div className="col-auto  pl-0">
        <div className="row cfa-nowrap-row justify-content-center">
          <div className="col-auto pl-0">
            <div>
              {props.loading && (
                <div className="cart-spinner">
                  <img
                    alt="cfa-icon"
                    src="/assets/images/CFA_CSymbol_Circle_Red_RGB.png"
                    className="cfa-icon-cart"
                  />
                  <div className="loader"></div>
                </div>
              )}
              {!props.loading && (
                <div
                  className={
                    props.pulse && props.update
                      ? 'cart-spinner-not-loading cfa-cart-badge-count pulse'
                      : 'cart-spinner-not-loading cfa-cart-badge-count'
                  }
                >
                  <div className="cfa-cart-badge-container">
                    <div className="cfa-cart-badge-number">1</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartIcon;
